/**
 * @file 订单相关hooks
 */
import { useState, useRef, useEffect } from 'react';
import { getOrderStatus } from '@/services/order';
import { OrderStatus, OrderStatusData } from '@/types/order';

export const PendingArr = [OrderStatus.PENDING, OrderStatus.INIT];
export const SuccessArr = [OrderStatus.SUCCESS];
export const FailArr = [
  OrderStatus.FAIL,
  OrderStatus.FAIL_PARTIAL,
  OrderStatus.CANCEL,
  OrderStatus.TIMEOUT,
];
/**
 * 云钱包提交链上操作后，查询订单状态
 */
export const useOrderStatus = (orderCode: string) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const [orderStatusData, setOrderStatusData] = useState<OrderStatusData>({
    status: OrderStatus.PENDING,
    finishTime: 0,
    hash: '',
  });
  const fetchData = async (orderCode: string) => {
    const { result } = await getOrderStatus(orderCode);

    setOrderStatusData(result);

    if (PendingArr.includes(result.status)) {
      timer.current = setTimeout(() => fetchData(orderCode), 3000);
    }
  };

  useEffect(() => {
    if (orderCode) {
      fetchData(orderCode);
    }
  }, [orderCode]);

  return {
    orderStatusData,
  };
};
